<template>
    <div class="withUs">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div class="contentLeft">
                        <ul>
                            <li class="publicTop">
                                <img src="../../assets/img/index/withUs.png" alt="">
                                <div style="margin-left: 5px;">关于我们</div>
                            </li>
                            <li v-for="(item, index) in menuList" :key="index" :class="active == index ? 'active' : ''" @click="activeChange(item, index)">
                                <img src="../../assets/img/index/arrows4.png" alt="" v-if="active == index">
                                <div style="width: 12px;" v-else></div>
                                <span style="margin-left: 10px;">{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="contentRight">
                        <div v-if="active == 0" class="leadership">
                            <div class="top">
                                <div style="font-size: 20px;color: #333;">单位介绍</div>
                                <div class="info">
                                    <span>企业信用建设服务平台</span>
                                    <div class="interval"></div>
                                    <span>http://www.qiyexinyong.org.cn</span>
                                    <div class="interval"></div>
                                    <span>发布时间：{{ info.createTime }}</span>
                                </div>
                            </div>
                            <div class="bottom" v-html="info.unitIntroduction"></div>
                        </div>
                        <div v-if="active == 1" class="leadership">
                            <div class="top">
                                <div style="font-size: 20px;color: #333;">委员信息</div>
                                <div class="info">
                                    <span>企业信用建设服务平台</span>
                                    <div class="interval"></div>
                                    <span>http://www.qiyexinyong.org.cn</span>
                                    <div class="interval"></div>
                                    <span>发布时间：{{ info.createTime }}</span>
                                </div>
                            </div>
                            <div class="bottom" v-html="info.memberUnit"></div>
                        </div>
                        <div v-if="active == 2" class="leadership">
                            <div class="top">
                                <div style="font-size: 20px;color: #333;">工作条例</div>
                                <div class="info">
                                    <span>企业信用建设服务平台</span>
                                    <div class="interval"></div>
                                    <span>http://www.qiyexinyong.org.cn</span>
                                    <div class="interval"></div>
                                    <span>发布时间：{{ info.createTime }}</span>
                                </div>
                            </div>
                            <div class="bottom" v-html="info.workRegulations"></div>
                        </div>
                        <div v-if="active == 3" class="leadership">
                            <div class="top">
                                <div style="font-size: 20px;color: #333;">主要工作</div>
                                <div class="info">
                                    <span>企业信用建设服务平台</span>
                                    <div class="interval"></div>
                                    <span>http://www.qiyexinyong.org.cn</span>
                                    <div class="interval"></div>
                                    <span>发布时间：{{ info.createTime }}</span>
                                </div>
                            </div>
                            <div class="bottom" v-html="info.mainWork"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
export default {
    name: 'withUs',
    components: {
        publicHeaders,
        foot
    },
    data() {
        return {
            documentTitle: '',
            menuList: [
                {
                    name: '单位介绍',
                },
                {
                    name: '委员信息',
                },
                {
                    name: '工作条例',
                },
                {
                    name: '主要工作',
                },
            ],
            active: 0,
            detail: {
                // title: '海南：5年来制定30余项涉生态文明领域省级政策法规法制建设助力海南生态文明驶入快车道',
                // source: '企业信用建设服务平台',
                // web: 'http://www.ccbn.org.cn',
                // time: '2023/8/4',
                // updateTime: '2023-05-14',
                // content: '<div><img src="https://img0.baidu.com/it/u=397682363,392992828&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500" alt="" style="margin: 30px auto;"></div><p>对领导班子总体评价和存在问题及对领导班子意见建议下面是我为大家整理的对领导班子总体评价和存在问题及对领导班子意见建议,供大家参考。对领导班子的总体评价和存在的问题及对</p><div><img src="https://img1.baidu.com/it/u=3077371267,719030592&fm=253&fmt=auto&app=138&f=JPEG?w=692&h=500" alt="" style="margin: 30px auto;"></div>',
            },
            info: {}
        }
    },
    created() {
        window.scrollTo(0 ,0)
        this.documentTitle = this.$route.query.documentTitle
        document.title = this.documentTitle || '关于我们'
        this.active = Number(this.$route.query.active || 0)

        this.getIndexInfo()
    },
    mounted() {
    },
    methods: {
        getIndexInfo() {
            let _this = this
            api.getIndexInfo().then(res => {
                let { data } = res
                if (data.status == 200) {
                    _this.info = data.data.websiteInfo
                    console.log(_this.info);
                } else {
                    
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },
        // 切换菜单
        activeChange(item, index) {
            this.active = index
        }
    }
}
</script>

<style lang="less" scoped>
.withUs {
    position: relative;
    padding-bottom: 140px;
    .main {
        width: 80%;
        padding: 15px 50px;
        margin: 0 auto;
        @media only screen and (min-width: 769px) {
            min-width: 1152px;
        }
        .left {
            margin-right: 5px;
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 600px;
                margin-top: 10px;
                display: flex;
                justify-content: space-between;
                .contentLeft {
                    width: 26%;
                    height: 230px;
                    .publicTop {
                        display: flex;
                        align-items: center;
                        background: linear-gradient(to bottom, #EAF6FF, #ECF7FF, #DEF0FF, #E9F5FF, #F6FBFF);
                        color: #1A68E8;
                    }
                    li {
                        display: flex;
                        justify-content: left;
                        align-items: center;
                        padding: 0 15px;
                        height: 46px;
                        line-height: 46px;
                        font-size: 20px;
                        color: #666;
                        cursor: pointer;
                        border: 1px solid #D9D9D9;
                        img {
                            display: inline-block;
                        }
                    }
                    li:nth-of-type(n+2) {
                        border-top-color: #fff;
                    }
                    .active {
                        color: #1A68E8;
                        border: 1px solid #1A68E8;
                        border-top-color: #1A68E8 !important;
                    }
                }
                .contentRight {
                    width: 73%;
                    border: 1px solid #D9D9D9;
                    padding: 10px 30px;
                    .leadership {
                        .top {
                            text-align: center;
                            padding: 15px 0;
                            border-bottom: 1px solid #D9D9D9;
                            .info {
                                margin-top: 15px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                color: #666;
                                font-size: 16px;
                                .interval {
                                    width: 1px;
                                    height: 20px;
                                    background-color: #666;
                                    margin: 0 25px;
                                }
                            }
                        }
                        .bottom {
                            padding: 20px 0;
                            line-height: 32px;
                            text-align: justify;
                            text-justify: inter-ideograph;
                            word-break: break-word;
                            /deep/ p,
                            /deep/ div,
                            /deep/ span {
                                text-align: justify;
                                text-justify: inter-ideograph;
                            }
                            /deep/ img {
                                max-width: 100%;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
